import { CashierShiftTransaction } from '@mews-commander/data-access';
import { Link } from '@optimus-web/core';
import { useDialog } from '@mews/framework';
import { TransactionDetailPanel } from '../../modals/transactionDetail/TransactionDetailPanel';

interface Props {
    transaction: CashierShiftTransaction;
}

export const TransactionNumber = ({ transaction }: Props) => {
    const [{ onClose, active }, toggleDetail] = useDialog();

    return (
        <>
            <Link variant="basic" onClick={toggleDetail}>
                {transaction.number}
            </Link>

            <TransactionDetailPanel transaction={transaction} opened={active} onClose={onClose} />
        </>
    );
};
